
import { defineComponent, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { addSortQuery } from '@/types/forms/sort-switch'

export default defineComponent({
  props: {
    sort: {
      type: Boolean,
      'default': () => (true),
    },
  },
  emits: ['update:sort'],
  setup(props, context) {
    const router = useRouter()
    const route = useRoute()

    const updateSort = computed({
      get() {
        return props.sort
      },
      set(value: boolean) {
        context.emit('update:sort', value)
        router.push({ path: route.path, query: addSortQuery(value) })
      }
    })

    return {
      updateSort
    }
  },
})
